import type { ValuesUnion } from "../../types/valuesUnion";

export const FrontendAllowedFileTypes = {
  AI: "ai",
  CSV: "csv",
  DOC: "doc",
  DOCX: "docx",
  DWG: "dwg",
  DXF: "dxf",
  GIF: "gif",
  HTML: "html",
  JPG: "jpg",
  KEY: "key",
  MSG: "msg",
  NUMBERS: "numbers",
  PAGES: "pages",
  PDF: "pdf",
  PNG: "png",
  PPT: "ppt",
  PPTX: "pptx",
  PSD: "psd",
  REX: "rex", // (wbuchanan): Regrello blueprint export file
  SVG: "svg",
  TIFF: "tiff",
  TXT: "txt",
  WEBP: "webp",
  XLS: "xls",
  XLSX: "xlsx",
  XML: "xml",
  ZIP: "zip",
} as const;

export type FrontendAllowedFileTypes = ValuesUnion<typeof FrontendAllowedFileTypes>;

/* eslint-disable lingui/no-unlocalized-strings */
function getMimetypeForExtension(ext: FrontendAllowedFileTypes): string | undefined {
  switch (ext) {
    case FrontendAllowedFileTypes.AI:
      return "application/*";
    case FrontendAllowedFileTypes.CSV:
      return "text/*";
    case FrontendAllowedFileTypes.DOC:
      return "application/*";
    case FrontendAllowedFileTypes.DOCX:
      return "application/*";
    case FrontendAllowedFileTypes.DWG:
      return "image/*";
    case FrontendAllowedFileTypes.DXF:
      return "image/*";
    case FrontendAllowedFileTypes.GIF:
      return "image/*";
    case FrontendAllowedFileTypes.HTML:
      return "text/*";
    case FrontendAllowedFileTypes.JPG:
      return "image/*";
    case FrontendAllowedFileTypes.KEY:
      return "application/*";
    case FrontendAllowedFileTypes.MSG:
      return "application/*";
    case FrontendAllowedFileTypes.NUMBERS:
      return "application/*";
    case FrontendAllowedFileTypes.PAGES:
      return "application/*";
    case FrontendAllowedFileTypes.PDF:
      return "application/*";
    case FrontendAllowedFileTypes.PNG:
      return "image/*";
    case FrontendAllowedFileTypes.PPT:
      return "application/*";
    case FrontendAllowedFileTypes.PPTX:
      return "application/*";
    case FrontendAllowedFileTypes.PSD:
      return "application/*";
    case FrontendAllowedFileTypes.REX:
      return "application/*";
    case FrontendAllowedFileTypes.SVG:
      return "image/*";
    case FrontendAllowedFileTypes.TIFF:
      return "image/*";
    case FrontendAllowedFileTypes.TXT:
      return "text/*";
    case FrontendAllowedFileTypes.WEBP:
      return "image/*";
    case FrontendAllowedFileTypes.XLS:
      return "application/*";
    case FrontendAllowedFileTypes.XLSX:
      return "application/*";
    case FrontendAllowedFileTypes.XML:
      return "text/*";
    case FrontendAllowedFileTypes.ZIP:
      return "application/*";
    default:
      return undefined;
  }
}
/* eslint-enable lingui/no-unlocalized-strings */

export type AllowedMimeTypesMap = Record<string, Array<`.${FrontendAllowedFileTypes}`>>;
export function getAllowedMapForExtensions(extensions: FrontendAllowedFileTypes[]) {
  const allowedMap: AllowedMimeTypesMap = {};
  for (const ext of extensions) {
    const mimeType = getMimetypeForExtension(ext);
    if (mimeType == null) {
      continue;
    }
    if (allowedMap[mimeType] == null) {
      allowedMap[mimeType] = [];
    }
    allowedMap[mimeType].push(`.${ext}`);
  }
  return allowedMap;
}

export const AllAllowedFileTypes = Object.values(FrontendAllowedFileTypes);
